// extracted by mini-css-extract-plugin
module.exports = {"createTicketButton":"default_createTicketButton__11NRd","createTicketButtonIcon":"default_createTicketButtonIcon__1LS-u"};